import { defineComponent as s, toRef as t, h as o } from "vue";
import a from "./ghl-ui.es1575.js";
import i from "./ghl-ui.es908.js";
import n from "./ghl-ui.es905.js";
import { resolveSlot as c } from "./ghl-ui.es860.js";
import u from "./ghl-ui.es862.js";
import d from "./ghl-ui.es1495.js";
const _ = s({
  name: "BaseClear",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    show: Boolean,
    onClear: Function
  },
  setup(e) {
    return i("-base-clear", a, t(e, "clsPrefix")), {
      handleMouseDown(r) {
        r.preventDefault();
      }
    };
  },
  render() {
    const {
      clsPrefix: e
    } = this;
    return o("div", {
      class: `${e}-base-clear`
    }, o(n, null, {
      default: () => {
        var r, l;
        return this.show ? o("div", {
          key: "dismiss",
          class: `${e}-base-clear__clear`,
          onClick: this.onClear,
          onMousedown: this.handleMouseDown,
          "data-clear": !0
        }, c(this.$slots.icon, () => [o(u, {
          clsPrefix: e
        }, {
          default: () => o(d, null)
        })])) : o("div", {
          key: "icon",
          class: `${e}-base-clear__placeholder`
        }, (l = (r = this.$slots).placeholder) === null || l === void 0 ? void 0 : l.call(r));
      }
    }));
  }
});
export {
  _ as default
};
